import React, { forwardRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PrintHeader from "../../../../Components/PrintHeader";

const Print = forwardRef(({ data }, ref) => {
  const { t } = useTranslation();

  useEffect(() => {
    const printStyles = `
      @media print {
        @page {
          size: 80mm auto;
          margin: 0;
        }
        html, body {
          margin: 0;
          padding: 0;
          height: 100%;
          overflow: hidden;
        }
        body * {
          visibility: hidden;
        }
        #printable, #printable * {
          visibility: visible;
        }
        #printable {
          position: absolute;
          left: 0;
          top: 0;
          width: 80mm;
          margin: 0;
          padding: 0;
        }
      }
    `;
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return (
    <div
      ref={ref}
      id="printable"
      style={{
        width: "80mm",
        fontFamily: "Arial, sans-serif",
        padding: "15px",
        boxSizing: "border-box",
      }}
    >
      <PrintHeader />

      {/* Advance Form Header */}
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <h3 style={{ margin: "0", fontSize: "16px", fontWeight: "bold" }}>
          {t("hr.bonusForm")}
        </h3>
      </div>

      {/* Details */}
      <div style={{ fontSize: "14px", lineHeight: "1.6", color: "#333" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <strong>{t("hr.employee")}:</strong>
          <span>{data.employee_display}</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <strong>{t("hr.month")}:</strong>
          <span>{data.month_display}</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <strong>{t("hr.year")}:</strong>
          <span>{data.year}</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <strong>{t("hr.amount")}:</strong>
          <span>{data.amount}؋</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <strong>{t("hr.paidDate")}:</strong>
          <span>{data.date}</span>
        </div>
      </div>

      {/* Footer */}
      <hr style={{ border: "1px dashed #333", margin: "15px 0" }} />
      <div style={{ textAlign: "center", color: "#555" }}>
        <p style={{ fontSize: "11px", margin: "8px 0" }}>{t("print.cosmos")}</p>
      </div>
    </div>
  );
});

export default Print;
